import { render, staticRenderFns } from "./NotAllowed.vue?vue&type=template&id=4e2953af&scoped=true&"
import script from "./NotAllowed.vue?vue&type=script&lang=js&"
export * from "./NotAllowed.vue?vue&type=script&lang=js&"
import style0 from "./NotAllowed.vue?vue&type=style&index=0&id=4e2953af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2953af",
  null
  
)

export default component.exports